var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      key:
        "message-counter-" +
        _vm.deliverable.id +
        "-" +
        _vm.deliverable.total_unread_messages_in_conversation,
      class: _vm.getClasses
    },
    [
      _vm.deliverable.total_unread_messages_in_conversation > 0
        ? _c("span", {
            staticClass: "message-count",
            domProps: {
              innerHTML: _vm._s(
                _vm.deliverable.total_unread_messages_in_conversation
              )
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.deliverable.total_unread_messages_in_conversation > 0 &&
      !_vm.deliverable.is_master
        ? _c("img", {
            staticClass: "chat-bubbles-unread",
            attrs: { src: require("@/csmworkflow/img/chat-bubbles-unread.svg") }
          })
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }